import "../style/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        <div className="footer-brand">
          <h3>Quality for Outcomes</h3>

          <p className="footer-tagline">
            Strong programs. Real impact. Smart funding.
          </p>

          <p className="footer-small">
            © {new Date().getFullYear()} Quality for Outcomes Group Pty Ltd.
            All rights reserved.
          </p>

          <p className="footer-small">
            ABN 19 692 786 495
          </p>
        </div>

        <div className="footer-section">
          <h4>Contact us</h4>

          <a href="mailto:info@qualityoutcomes.au">
            ✉ info@qualityoutcomes.au
          </a>

          <a href="tel:+61418744433">
            ☎ +61 418 744 433
          </a>

          <a
            href="https://www.linkedin.com/company/quality-for-outcomes/"
            target="_blank"
            rel="noreferrer"
          >
            🔗 LinkedIn
          </a>

          <a
            href="https://www.qualityoutcomes.au/"
            target="_blank"
            rel="noreferrer"
          >
            🌐 Website
          </a>
        </div>

        <div className="footer-about">
          <h4>About us</h4>

          <p>
            Quality for Outcomes supports organisations design and deliver
            impactful programs and funders invest with clarity and confidence.
            From strategic advice, practical frameworks and digital tools, we
            help you design stronger programs, align them with strategy, and
            clearly demonstrate the difference they make. So you can deliver
            work that stands up, and secure, justify or maximise funding.
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;